// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1GLoS","fileBtn":"File_fileBtn__E2Qvv","closeBtn":"File_closeBtn__1rvd7","fileSelected":"File_fileSelected__6NfAh","disabled":"File_disabled__1m5s2"};